import { Typography } from '@mui/material';
import { StackedTextCell } from '@retail/components';

interface Props {
  oldValue: string | number;
  newValue?: string | number;
  hasNewValue: boolean;
  approximatelyEqual?: boolean;
  textColor?: 'primary' | 'secondary';
}

export function FieldValueView({
  oldValue,
  newValue,
  hasNewValue,
  approximatelyEqual,
  textColor,
}: Props) {
  const useTextColor = textColor === 'primary' ? 'text.primary' : 'text.secondary';
  return hasNewValue ? (
    <StackedTextCell
      centerAlign
      gap="small"
      topLine={
        <Typography variant="body2" color={useTextColor}>{`${
          approximatelyEqual ? '≈ ' : ''
        }${newValue}`}</Typography>
      }
      bottomLine={
        <Typography color={useTextColor} variant="body2" sx={{ textDecoration: 'line-through' }}>
          {oldValue}
        </Typography>
      }
    />
  ) : (
    <Typography variant="body2" color={useTextColor}>
      {oldValue}
    </Typography>
  );
}
